import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';

import { ReactComponent as NrgStagwellIcon } from '../../icons/svg/nrg-stagwell.svg';

export default class Footer extends NrgComponent {

  render() {
    return (
      <footer className="Footer row">
        <div className="col-xs-16 col-md-4 logo">
          <div className="col-xs-16">
            <div className="nrg-logo">
              <NrgStagwellIcon viewBox="0 0 307.1 113.6"></NrgStagwellIcon>
            </div>
          </div>
        </div>
        <div className="col-xs-16 col-sm-8 col-md-5 contact-info">
          <div className="row">
            <div className="col-xs-8">
              <h4>{Content.contact.title}</h4>
              <span><a href={`mailto:${Content.contact.email}`}>{Content.contact.email}</a></span>
              <span><a href={`tel:${Content.contact.phone}`}>{Content.contact.phone}</a></span>
              <span><a href={Content.contact.linkedin}>LinkedIn</a></span>
                <br />
                <span><a href={Content.contact.privacy_href}>{Content.contact.privacy_title}</a></span>
                <span><a href={Content.contact.ccpa_href}>{Content.contact.ccpa_title}</a></span>
            </div>
            <div className="col-xs-8">
              <h4>{Content.careers.title}</h4>
              <span><a href={Content.careers.href}>{Content.careers.openings}</a></span>
            </div>
          </div>
        </div>
        <div className="col-xs-16 col-sm-8 col-md-6 addresses">
          <div className="row">
            <div className="col-xs-4">
              <h4>{Content.london.title}</h4>
              <span>{Content.london.address_1}</span>
              <span>{Content.london.address_2}</span>
              <span>{Content.london.address_3}</span>
              <span>{Content.london.address_4}</span>
              <span>{Content.london.address_5}</span>
            </div>
            <div className="col-xs-4">
              <h4>{Content.la.title}</h4>
              <span>{Content.la.address_1}</span>
              <span>{Content.la.address_2}</span>
              <span>{Content.la.address_3}</span>
            </div>
            <div className="col-xs-4">
              <h4>{Content.ny.title}</h4>
              <span>{Content.ny.address_1}</span>
              <span>{Content.ny.address_2}</span>
              <span>{Content.ny.address_3}</span>
              <span>{Content.ny.address_4}</span>
            </div>
			<div className="col-xs-4">
              <h4>{Content.si.title}</h4>
              <span>{Content.si.address_1}</span>
              <span>{Content.si.address_2}</span>
              <span>{Content.si.address_3}</span>
            </div>
          </div>
        </div>
        <div className="col-xs-16">
          <div className="footnote">{Content.footnote}</div>
        </div>
      </footer>
    );
  }

};
